import React from "react";

const Footer = () => {
  return (
    <div className="footer-wrapper">
      <p className="footer-text">© Kiiltäväx Oy 2023</p>
    </div>
  );
};

export default Footer;
